<template lang="html">
  <section :type="navigatorType">
    <div class="container-popup" :show="show">
      <a @click="show = false" class="cerrar">✕</a>
      <a @click="mandarClicks" target="_blank" class="banner-video">
        <!-- <h2 v-html="$t('popupretenes.title')"></h2> -->
        <h2>AJUSA VIDEOS</h2>
        <img
          class="icon-youtube"
          src="/static/img/banner-app/icon-youtube.webp"
          alt="Icon Youtube"/>
        <b
          >Professional <br />
          installation</b
        >
        <p class="text-product">full gasket set</p>
        <b
          >Instalación<br />
          profesional</b
        >
        <p class="text-product -second">juegos de juntas</p>

        <img src="/static/img/banner-app/ipad-popup.webp" class="ipad" alt=""
      /></a>
    </div>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'
  export default  {
    name: 'banner-video',
    props: [],
    data() {
      return{
        idbanner : 1,
        show : false
      }
    },
    computed : {
      navigatorType : function(){
        let type = (navigator.userAgent.includes('Android')) ? 'android' : false;
        (!!!type) ? type = ((navigator.userAgent.includes('Mac')) ? 'ios' : 'other') : 'other';
        return type;
      }
    },
    mounted() {
      this.show = true;
    },
    methods: {


      mandarClicks: function (event) {
        window.open('https://www.youtube.com/watch?v=vKe5Qh8L5m8', '_blank');
        this.$ga.event({
        eventCategory: 'popup',
        eventAction: 'clic',
        eventLabel: 'youtube',
        eventValue: 0,

      })


    }




    },


  }
</script>

<style scoped>
.banner-video {
  background: #ff0096;
  padding: 110px 20px 20px 20px;
  max-width: 190px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-direction: column;
  -moz-flex-direction: column;
  -ms-flex-direction: column;
  -o-flex-direction: column;
  flex-direction: column;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  -ms-align-items: flex-end;
  align-items: flex-end;
  -webkit-align-items: flex-end;
}
.container-popup[show="true"] .ipad {
  position: absolute;
  right: -90px;
  top: -115px;
  max-width: 180px;
  width: 100%;
  transform: rotate(-79deg) translateX(0);
  opacity: 1;
  transition: 2s;
  transition-delay: 3.5s;
}
.ipad {
  position: absolute;
  right: -90px;
  top: -115px;
  max-width: 180px;
  width: 100%;
  opacity: 0;
  transform: rotate(50deg) translateX(-800px);
  transition: 1s;
}
.container-popup {
  position: fixed;
  left: -500px;
  bottom: 10vh;
  z-index: 180;
  transition: 2s;
}
.container-popup[show="true"] {
  transition: 2s;
  transition-delay: 2.5s;
  transform: translateX(500px);
}

h2 {
  text-transform: uppercase;
  margin-bottom: 10px;
  width: 100%;
  display: inline-block;
  font-size: 20px;
  line-height: 20px;
  margin-top: 0;
  max-width: 230px;
  text-align: right;
  color: white;
}

p {
  font-size: 13px;
  color: white;
  line-height: 16px;
}
b {
  color: white;
  font-size: 18px;
  text-align: right;
  font-weight: bold;
  line-height: 24px;
}
i {
  color: white;
  font-size: 18px;
  text-align: right;
  font-style: italic;
  line-height: 20px;
}
.text-product:before {
  content: "";
  display: inline;
  background: #ffed00;
  width: 19px;
  height: 3px;
  position: absolute;
  right: 0;
  bottom: -15px;
}
.text-product.-second:before {
  display: none;
}
.text-product {
  position: relative;
  margin-bottom: 30px;
}

.cerrar {
  z-index: 180;
  width: 53px;
  height: 54px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 20px;
  margin-bottom: 15px;
  padding: 0;
  position: absolute;
  top: 0;
  /* background: gray; */
  display: flex;
  align-items: center;
  justify-content: center;
}

[show="true"] .movil {
  transition: 1s;
  transition-delay: 2.5s;
  transform: translate(0px, 0px);
}

.icon-youtube {
  max-width: 32px;
  width: 100%;
  margin-bottom: 10px;
}

@media screen and (max-width: 800px) {
  .banner-video {
    padding: 40px 10px 0px 10px;
    max-width: 100px;
  }
  h2 {
    font-size: 18px;
    line-height: 20px;
  }
  .icon-youtube {
    max-width: 25px;
  }
  b {
    font-size: 15px;
    line-height: 18px;
  }
  p {
    font-size: 11px;
    line-height: 16px;
  }
  .cerrar {
    width: 35px;
    height: 35px;
  }
  .container-popup[show="true"] .ipad {
    right: -70px;
    top: -70px;
    max-width: 90px;
  }
  .text-product {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 650px) {
  .container-popup[show="true"] .ipad {
    position: absolute;
    right: -34px;
    top: -76px;
    max-width: 150px;
  }
  h2 {
    font-size: 14px;
    line-height: 16px;
  }
  b {
    font-size: 12px;
    line-height: 14px;
  }
  p {
    font-size: 9px;
    line-height: 13px;
  }
  .text-product {
    margin-bottom: 10px;
  }
  .text-product:before {
    bottom: -5px;
    height: 2px;
  }
  .container-popup[show="true"] .ipad {
    top: -50px;
    max-width: 70px;
  }
  .cerrar {
    font-size: 13px;
  }
  .banner-video{
    max-width: 95px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/banner-video.vue